import { render, staticRenderFns } from "./Configuracao.vue?vue&type=template&id=149507ba&scoped=true"
import script from "./Configuracao.vue?vue&type=script&setup=true&lang=js"
export * from "./Configuracao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149507ba",
  null
  
)

export default component.exports